import { redirect, createFileRoute } from '@tanstack/react-router';
import { requireAnyPermission } from '@/lib/route-guards/permission-guard';

export const Route = createFileRoute('/_authenticated/_app/settings/meeting/')({
	beforeLoad: async ({ context }) => {
		await requireAnyPermission({ context, anyOf: ['meetings.manageSettings'] });
		throw redirect({ to: '/settings/meeting/defaults' });
	},
});
